import { ConvexReactClient } from "convex/react";

// Import der Convex-URL aus der Umgebungsvariable
const convexUrl = import.meta.env.VITE_CONVEX_URL;

// Erstelle den Convex-Client für die React-Integration
export const convex = new ConvexReactClient(convexUrl);
